import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'antd';
import styled from '@emotion/styled';

const TooltipContainer = styled('div')(({ type }) => {
  if (type) {
    let border;
    let background;

    if (type === 'error') {
      border = 'var(--color-error-border)';
      background = 'var(--color-error-background)';
    }

    if (type === 'warning') {
      border = 'var(--color-warning-border)';
      background = 'var(--color-warning-background)';
    }

    return `
      .ant-tooltip-container {
        background: ${background};
        border: 1px solid ${border};
        color: var(--color-text);
        padding: var(--spacing-xs) var(--spacing-sm);
      }
      .ant-tooltip-arrow {
        &::before {
          background: ${border};
        }
      }
    `;
  }
});

/**
 * @param {('error'|'warning')} type
 */
const AlertTooltip = ({ children, type, ...tooltipProps }) => {
  const containerRef = useRef();
  return (
    <>
      {createPortal(
        <TooltipContainer ref={containerRef} type={type} />,
        document.body,
      )}
      <Tooltip
        getPopupContainer={() => {
          return containerRef.current;
        }}
        {...tooltipProps}
      >
        {children}
      </Tooltip>
    </>
  );
};

export default AlertTooltip;
